import { ACCESS_TOKEN } from '../Constants';

const request = (options) => {
	const headers = new Headers( {
		Accept: 'application/json', 
		'Content-Type' : 'application/json'
	})
	
	if(localStorage.getItem(ACCESS_TOKEN)) {
		headers.append('Authorization', 'Bearer ' + localStorage.getItem(ACCESS_TOKEN))
	}

	const defaults = {headers: headers};
	options = Object.assign({}, defaults, options);

	return fetch(options.url, options)
	.then(response => 
		response.json().then(json => {
			if(!response.ok) {
				return Promise.reject(json);
			}
			return json;
		})
	)
};

export function getUserData(currentUser) {
	return request({
			url: "/webpub-services/WPUserAPI/getWPUserById/"+currentUser,
			method: 'GET'
	});
}

export function login(loginRequest) {
	return request({
		url: "/webpub-services/auth/login",
		method: 'POST',
		body: JSON.stringify(loginRequest)
	});
}

export function getCurrentUser() {
	if(!localStorage.getItem(ACCESS_TOKEN)) {
		return Promise.reject("No access token set.");
	}

	return request({
		url: "/webpub-services/auth/me",
		method: 'GET'
	});
}

export function requestPasswordReset(resetObject) {
	return request({
		url: "/webpub-services/auth/requestPasswordReset",
		method: 'PUT',
		body: JSON.stringify(resetObject)
	});
}